// actions/types.ts

// =========================
// Action Types for Redux
// =========================

/**
 * Set the logged-in user's Firebase UID.
 * Used for secure identification and role-based access.
 */
export const SET_USER_UID = "SET_USER_UID";
